module.exports = (api)->
  (id)->
    api
      provider: "hull"
      path: [id, 'flag'].join('/')
    ,'post'



/** WEBPACK FOOTER **
 ** ./src/client/flag/index.coffee
 **/